<template>
  <div class="row">
    <b-container fluid>
      <b-card
          no-body
          class="mt-md-1"
      >
        <b-overlay
            :show="isLoading"
            rounded="sm"
        >
          <div class="m-1">
            <b-row>
              <b-col
                  cols="8"
                  md="8"
              >
                <h3>{{ modalTitle }}</h3>
              </b-col>
              <b-col
                  cols="4"
                  md="4"
              >
                <div class="text-right">
                  <b-button
                      v-b-modal.credentialSampleSaveModal
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      size="sm"
                      class="ml-1"
                      @click="onCreateCredentialSample"
                  >
                    <span

                        class="text-nowrap text-right d-none d-lg-block"
                    >
                      <feather-icon icon="PlusIcon" /> Thêm mới
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-button
                    variant="secondary"
                    class="my-2"
                    @click="downloadFile"
                >
                        <span class="text-nowrap text-right">
                          <feather-icon icon="DownloadIcon" /> Tải file cấu hình các biến cho file mẫu
                        </span>
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-0">
                  <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                    đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                  </span>
                </div>
                <vue-good-table
                    mode="remote"
                    class="my-table"
                    row-style-class="vgt-row"
                    style-class="vgt-table striped bordered"
                    :columns="columns"
                    :rows="credentialSamples"
                    :pagination-options="paginationOptions"
                    :total-rows="totalRows"
                    :line-numbers="true"
                    @on-page-change="onPageChange"
                    @on-per-page-change="onPerPageChange"
                >
                  <div
                      slot="emptystate"
                      style="text-align: center; font-weight: bold"
                  >Không có bản ghi nào</div>
                  <template
                      slot="table-row"
                      slot-scope="props"
                  >
                    <span v-if="props.column.field === 'status'">
                      {{ getStatusName(props.row.status) }}
                    </span>
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                    <span
                        v-if="props.column.field === 'action'"
                        class="thead-group-action"
                    >
                      <b-button-group>
                        <b-button
                            v-b-modal.credentialSampleSaveModal
                            class="btn-icon"
                            variant="primary"
                            size="sm"
                            title="Chỉnh sửa"
                            @click="onUpdateCredentialSample(props.row)"
                        >
                          <feather-icon icon="Edit2Icon" />
                        </b-button>

                        <b-button
                            class="btn-icon"
                            variant="danger"
                            size="sm"
                            title="Xóa"
                            @click="onDeleteCredentialSample(props.row)"
                        >
                          <feather-icon icon="TrashIcon" />
                        </b-button>

                        <b-button
                            v-b-modal.credentialSampleConfigModal
                            class="btn-icon"
                            variant="primary"
                            size="sm"
                            title="Cấu hình file mẫu"
                            @click="configCredentialSample(props.row)"
                        >
                          <feather-icon icon="ToolIcon" />
                        </b-button>
                      </b-button-group>
                    </span>
                  </template>
                  <!-- pagination -->
                  <template
                      slot="pagination-bottom"
                      slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                            v-model="filter.itemsPerPage"
                            :options="itemsPerPageOptions"
                            class="mx-1"
                            @input="(value) => props.onPerPageChange({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                            :value="1"
                            :total-rows="totalRows"
                            :per-page="filter.itemsPerPage"
                            class="mt-1 mb-0"
                            @input="(value) => props.onPageChange({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
      <CredentialSampleSave
          ref="credentialSampleSaveModal"
          :item="currentCredentialSample"
          :current-credential-id="currentCredentialId"
          @succeed="onSucceed"
      />
      <b-modal
          id="credentialSampleConfigModal"
          ref="credentialSampleConfigModal"
          ok-title="Xác nhận"
          cancel-title="Hủy"
          centered
          size="xl"
          :hide-header="true"
          @ok="onSucceed"
      >
        <CredentialSampleConfig
            :data-send="currentCredentialSample "
            :current-credential-sample-type="currentCredentialSampleType"
        />
      </b-modal>
    </b-container>

  </div>
</template>
<script>
import Ripple from 'vue-ripple-directive'
import {
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BFormSelect, BModal,
  BOverlay,
  BPagination, BRow,
  VBTooltip,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { getUser } from '@/auth/utils'
import '@core/scss/vue/libs/vue-good-table.scss'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CredentialImplementSave from '@/views/certificate/credential-implement/CredentialImplementSave.vue'
import CredentialSampleSave from '@/views/certificate/credential-sample/CredentialSampleSave.vue'
import CredentialSampleConfig from '@/views/certificate/credential-sample/CredentialSampleConfig.vue'
import {Workbook} from "@syncfusion/ej2-excel-export";

export default {
  name: 'CredentialSample',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  components: {
    CredentialSampleConfig,
    BModal,
    CredentialSampleSave,
    BButton,
    BButtonGroup,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
  },
  props: {
    dataSend: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        credentialId: this.dataSend.id || this.$route.params.id,
      },
      modalTitle: `Danh sách mẫu của [${this.dataSend.name}]`,
      currentCredentialSample: undefined,
      currentCredentialId: this.dataSend.id,
      currentCredentialSampleType: 0,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      columns: [
        {
          label: 'Tên',
          field: 'name',
          sortable: true,
          filterOptions: {
            enable: true,
            trigger: 'enter',
          },
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Loại phôi',
          field: 'certificateBlank',
          sortable: true,
          filterOptions: {
            enable: true,
            trigger: 'enter',
          },
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Trạng thái',
          field: 'status',
          sortable: true,
          filterOptions: {
            enable: true,
            trigger: 'enter',
          },
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          field: 'action',
          sortable: false,
          tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      statuses: 'credentialSample/statuses',
      credentialSamples: 'credentialSample/credentialSamples',
      totalRows: 'credentialSample/totalRows',
    }),
  },
  async created() {
    this.loading = true
    try {
      await this.readCredentialSamples(this.filter)
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: `[${e.code}] ${e.message}`,
          icon: 'XCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapActions({
      readCredentialSamples: 'credentialSample/readCredentialSamples',
      deleteCredentialSample: 'credentialSample/deleteCredentialSample',
    }),
    getStatusName(id) {
      return this.statuses.find(status => status.value === id).label
    },
    onCreateCredentialSample() {
      this.currentCredentialSample = undefined
    },
    onUpdateCredentialSample(row) {
      const {
        originalIndex,
        vgt_id,
        ...rest
      } = row
      this.currentCredentialSample = rest
    },
    onDeleteCredentialSample(credentialSample) {
      this.$swal({
        title: 'Bạn có chắc chắn muốn xóa?',
        text: `Xóa thời gian ${credentialSample.name}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          const response = await this.deleteCredentialSample(credentialSample.id)
          const { isSuccessful, message } = response
          if (response) {
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              try {
                await this.readCredentialSamples(this.filter)
              } catch (e) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: `[${e.code}] ${e.message}`,
                    icon: 'XCircleIcon',
                    variant: 'danger',
                  },
                })
              }
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
          try {
            await this.deleteCredentialSample(credentialSample.id)
          } catch (e) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `[${e.code}] ${e.message}`,
                icon: 'XCircleIcon',
                variant: 'danger',
              },
            })
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    async configCredentialSample(row) {
      const {
        originalIndex,
        vgt_id,
        ...rest
      } = row
      this.currentCredentialSample = rest
      this.currentCredentialSampleType = row.originalIndex
    },
    async getCredentialSampleFromStore() {
      this.isLoading = true
      try {
        await this.readCredentialSamples(this.filter)
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async onSucceed() {
      await this.getCredentialSampleFromStore()
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getCredentialSampleFromStore()
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getCredentialSampleFromStore()
    },
    downloadFile() {
      const columns = [
        { index: 1, value: 'MÃ', width: 130 },
        { index: 2, value: 'TÊN BIẾN', width: 200 },
      ];

      const rows = [
        {
          index: 1,
          cells: [
            {
              index: 1,
              value: 'MÃ CẤU HÌNH',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#ffffff',
                backColor: '#000000',
              },
            },
            {
              index: 2,
              value: 'TÊN BIẾN',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 2,
          cells: [
            {
              index: 1,
              value: '${name}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Họ và tên sinh viên',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 3,
          cells: [
            {
              index: 1,
              value: '${studentCode}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Mã sinh viên',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 4,
          cells: [
            {
              index: 1,
              value: '${birthday}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Ngày sinh',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 5,
          cells: [
            {
              index: 1,
              value: '${address}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Địa chỉ',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 6,
          cells: [
            {
              index: 1,
              value: '${gender}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Giới tính',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 7,
          cells: [
            {
              index: 1,
              value: '${nationality}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Quốc tịch',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 8,
          cells: [
            {
              index: 1,
              value: '${major}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Chuyên ngành',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 9,
          cells: [
            {
              index: 1,
              value: '${course}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Khóa học',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 10,
          cells: [
            {
              index: 1,
              value: '${credentialName}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Tên văn bằng, chứng chỉ',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 11,
          cells: [
            {
              index: 1,
              value: '${year}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Năm học',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 12,
          cells: [
            {
              index: 1,
              value: '${graduationText}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Loại tốt nghiệp',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 13,
          cells: [
            {
              index: 1,
              value: '${code}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Mã văn bằng, chứng chỉ',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 14,
          cells: [
            {
              index: 1,
              value: '${codeCredentialStorage}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Số vào sổ gốc',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
        {
          index: 15,
          cells: [
            {
              index: 1,
              value: '${trainingSystem}',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
            {
              index: 2,
              value: 'Hệ đào tạo',
              colSpan: 1,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                fontColor: '#000000',
                backColor: '#ffffff',
              },
            },
          ],
        },
      ];

      const worksheets = [{ columns, rows }];
      const workbook = new Workbook({ worksheets }, 'xlsx');
      workbook.save('file_cấu_hình_các_biến_cho_mẫu_VBCC.xlsx');
    },
  },
}
</script>

<style scoped lang="scss">
</style>
